// import React from "react";
// import { motion } from "framer-motion";
// import {
//   DollarSign,
//   Calendar,
//   CreditCard,
//   TrendingUp,
//   Edit
// } from "lucide-react";
// import { format } from "date-fns";
// import "../../css/payments/paymentcard.css";

// const statusClasses = {
//   Pending: "status pending",
//   Received: "status received",
//   Overdue: "status overdue"
// };

// // Updated: 06-04-2026 — Token, Booking, Final removed from payment types
// const typeClasses = {
//   Installment: "type installment",
//   Commission:  "type commission",
//   Other:       "type other",
// };

// const methodIcons = {
//   Cash: DollarSign,
//   Cheque: CreditCard,
//   "Bank Transfer": TrendingUp,
//   UPI: CreditCard,
//   Card: CreditCard
// };

// const fmtAmt = (n) =>
//   n >= 10_000_000 ? `₹${(n / 10_000_000).toFixed(2)}Cr`
//   : n >= 100_000   ? `₹${(n / 100_000).toFixed(1)}L`
//   : n >= 1_000     ? `₹${(n / 1_000).toFixed(0)}K`
//   : `₹${n}`;

// export default function PaymentCard({ payment, deal, index, onEdit }) {
//   const MethodIcon = methodIcons[payment.paymentMethod] || DollarSign;

//   return (
//     <motion.div
//       className="payment-card-wrapper"
//       initial={{ opacity: 0, y: 20 }}
//       animate={{ opacity: 1, y: 0 }}
//       transition={{ delay: index * 0.05 }}
//     >
//       <div className="payment-card">
//         {/* Header */}
//         <div className="payment-card-header">
//           <div className="header-left">
//             <div className="icon-circle">
//               <DollarSign size={22} />
//             </div>

//             <div className="badges">
//               <span className={typeClasses[payment.paymentType]}>
//                 {payment.paymentType}
//               </span>
//               <span className={statusClasses[payment.status]}>
//                 {payment.status}
//               </span>
//             </div>
//           </div>

//           <button className="edit-btn" onClick={onEdit}>
//             <Edit size={16} />
//           </button>
//         </div>

//         {/* Content */}
//         <div className="payment-card-content">
//           <div className="amount">
//             {/* <DollarSign size={18} /> */}
//             <span>{fmtAmt(payment.amount)}</span>
//           </div>

//           {deal && (
//             <div className="deal-info">
//               <strong>Deal:</strong> {deal.dealName}
//             </div>
//           )}

//           <div className="meta">
//             <div className="meta-row">
//               <Calendar size={14} />
//               <span>
//                 {format(new Date(payment.paymentDate), "dd MMM yyyy")}
//               </span>
//             </div>

//             {payment.dueDate && (
//               <div className="meta-row">
//                 <Calendar size={14} />
//                 <span>Due: {format(new Date(payment.dueDate), "dd MMM yyyy")}</span>
//               </div>
//             )}

//             <div className="meta-row">
//               <MethodIcon size={14} />
//               <span>{payment.paymentMethod}</span>
//             </div>
//           </div>

//           {payment.transactionRef && (
//             <div className="transaction-ref">
//               Ref: {payment.transactionRef}
//             </div>
//           )}

//           {payment.notes && (
//             <div className="notes">
//               {payment.notes}
//             </div>
//           )}
//         </div>
//       </div>
//     </motion.div>
//   );
// }
import React from "react";
import { motion } from "framer-motion";
import {
  DollarSign,
  Calendar,
  CreditCard,
  TrendingUp,
  Edit
} from "lucide-react";
import { format } from "date-fns";
import "../../css/payments/paymentcard.css";

const statusClasses = {
  Pending: "status pending",
  Received: "status received",
  Overdue: "status overdue"
};

// Updated: 06-04-2026 — Token, Booking, Final removed from payment types
const typeClasses = {
  Installment: "type installment",
  Commission:  "type commission",
  Other:       "type other",
};

const methodIcons = {
  Cash: DollarSign,
  Cheque: CreditCard,
  "Bank Transfer": TrendingUp,
  UPI: CreditCard,
  Card: CreditCard
};

const fmtAmt = (n) =>
  n >= 10_000_000 ? `₹${(n / 10_000_000).toFixed(2)}Cr`
  : n >= 100_000   ? `₹${(n / 100_000).toFixed(1)}L`
  : n >= 1_000     ? `₹${(n / 1_000).toFixed(0)}K`
  : `₹${n}`;

export default function PaymentCard({ payment, deal, index, onEdit }) {
  const MethodIcon = methodIcons[payment.paymentMethod] || DollarSign;

  return (
    <motion.div
      className="payment-card-wrapper"
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ delay: index * 0.05 }}
    >
      <div className="payment-card">
        {/* Header */}
        <div className="payment-card-header">
          <div className="header-left">
            <div className="icon-circle">
              <DollarSign size={22} />
            </div>

            <div className="badges">
              <span className={typeClasses[payment.paymentType]}>
                {payment.paymentType}
              </span>
              <span className={statusClasses[payment.status]}>
                {payment.status}
              </span>
            </div>
          </div>

          <button className="edit-btn" onClick={onEdit}>
            <Edit size={16} />
          </button>
        </div>

        {/* Content */}
        <div className="payment-card-content">
          <div className="amount">
            {/* <DollarSign size={18} /> */}
            <span>{fmtAmt(payment.amount)}</span>
          </div>

          {deal && (
            <div className="deal-info">
              <strong>Deal:</strong> {deal.dealName}
            </div>
          )}

          <div className="meta">
            <div className="meta-row">
              <Calendar size={14} />
              <span>
                {format(new Date(payment.paymentDate), "dd MMM yyyy")}
              </span>
            </div>

            {payment.dueDate && (
              <div className="meta-row">
                <Calendar size={14} />
                <span>Due: {format(new Date(payment.dueDate), "dd MMM yyyy")}</span>
              </div>
            )}

            <div className="meta-row">
              <MethodIcon size={14} />
              <span>{payment.paymentMethod}</span>
            </div>
          </div>

          {payment.transactionRef && (
            <div className="transaction-ref">
              Ref: {payment.transactionRef}
            </div>
          )}

          {payment.notes && (
            <div className="notes">
              {payment.notes}
            </div>
          )}
        </div>
      </div>
    </motion.div>
  );
}